// extracted by mini-css-extract-plugin
export default {"text":"PdfWarningModal_text__HHxVh","fetchButton":"PdfWarningModal_fetchButton__OLu99"};